import { createSlice } from '@reduxjs/toolkit'

export const gradeRiskCriteriaUI = createSlice({
  name: 'gradeRiskCriteriaI',
  initialState: {
    activeFilters: [] as string[],
    tableFilters: {
      search: '',
    },
  },
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    clearAllFilters: (state) => {
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  clearAllFilters,
} = gradeRiskCriteriaUI.actions

export default gradeRiskCriteriaUI.reducer
